import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { TANSTACK_QUERY_KEY } from '@/constants/tanstack-query'
import { IHttpError, Token } from '@/data'
import { useWallet } from '@/hooks'
import { IListTokens, ITokenCap } from '@/types'

export function useListToken() {
  const { walletAddresses } = useWallet()
  return useQuery<IListTokens, IHttpError>({
    queryKey: [TANSTACK_QUERY_KEY.TOKENS.GET_LIST_TOKEN, walletAddresses?.join(',')],
    queryFn: async () => {
      const response = await Token.listToken(walletAddresses || [])
      return response.data
    },
    placeholderData: keepPreviousData,
  })
}

export function useGetToken(symbol: string) {
  return useQuery<ITokenCap, IHttpError>({
    queryKey: [TANSTACK_QUERY_KEY.TOKENS.GET_TOKEN, symbol],
    queryFn: async () => {
      const response = await Token.getToken(symbol)
      return response.data
    },
    enabled: !!symbol,
    staleTime: 60_000,
    gcTime: 60_000,
    retry: 2,
  })
}
